<style scoped>
[contenteditable]:focus {
  outline: 0px solid transparent;
}

.tab-sheet {
  font-size: 10px;
  border-top: 0.5px solid #ccc;
  border-right: 0.5px solid #ccc;
  width: 100%;
  cursor: pointer;
}

.tab-sheet.active {
  border-top: 0;
}

.tab-sheet .text {
  padding: 5px 20px 5px 20px;
}

.bottom-nav {
  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 0;
  float: left;
  width: 100%;
  background-color: #fff;
}

.bottom-nav div {
  display: block;
  float: left;
  width: auto;
  cursor: pointer;
}
.pointer {
  cursor: pointer;
}
.spread-sheet {
  margin-bottom: 30px;
}

.active {
  color: #78cb5b;
}

.inactive {
  color: #fff000;
}

.fa.fa-circle:before {
  content: "\25C9";
  /*color: #000;*/
}

th {
  text-align: center;
}

td:nth-child(1) {
  text-align: center;
}

td:nth-child(3) {
  text-align: center;
}

td:nth-child(2) {
  padding-left: 40px;
}

.event-active {
  font-weight: bold;
  color: #78cb5b;
  text-transform: uppercase;
  letter-spacing: 1.2px;
}
.caption {
  cursor: pointer;
}
</style>

<template>
  <div style="height: 100%">
    <v-layout row wrap>
      <v-flex
        xs6
        style="text-align: left; padding-left: 25px; padding-top: 5px"
      >
        <span @click="setCurrentFolder(rootFolder)" class="title pointer">
          {{ this.namespaceDescription }}
        </span>
        <span v-for="item in breadcrumb" :key="item.id" v-if="item.id">
          <span class="title"> > </span>
          <span @click="setCurrentFolder(item)" class="title pointer">
            {{ item.name }}
          </span>
        </span>
      </v-flex>
      <v-flex xs6 style="text-align: right">
        <v-btn small v-on:click="createFolderDialog = true" align-right depressed
          >New Folder</v-btn
        >
        <v-btn small v-on:click="openUploadFilesDialog()" align-right depressed
          >Upload Files</v-btn
        >
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-container
      fluid
      grid-list-md
      v-if="activeFolderList && activeFolderList.length"
    >
      <h2 class="subheading">Folders</h2>
      <v-layout
        v-if="loadingFolders"
        fill-height
        align-center
        justify-center
        ma-0
      >
        <v-progress-circular
          indeterminate
          color="grey lighten-5"
        ></v-progress-circular>
      </v-layout>
      <v-data-iterator
        v-if="!loadingFolders"
        :hide-actions="hideFolderAction"
        :items="activeFolderList"
        item-key="name"
        :rows-per-page-items="folderRowsPerPageItems"
        :pagination.sync="folderPagination"
        content-tag="div"
        content-class="layout row wrap"
      >
        <template v-slot:item="props">
          <v-flex xs6 sm6 md4 lg2 xl1 @click="setCurrentFolder(props.item)">
            <v-card elevation="0">
              <v-card-text class="text-xs-center pointer">
                <v-icon style="font-size: 100px">folder</v-icon><br />
                <div class="text-truncate caption">
                  {{ props.item.name }} 
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </template>
      </v-data-iterator>
    </v-container>

    <v-container fluid grid-list-md v-if="!loadingFiles && (!fileList || !fileList.length) && (!folderList || !folderList.length)">
            <v-card
              style="height: 200px; cursor: pointer;"
              v-on:click="openUploadFilesDialog()"
              elevation="0"
            >
              <v-layout fill-height align-center justify-center>
                  <span class="">Click To Upload File (s)</span>
              </v-layout>
            </v-card>
    </v-container>

    <v-container fluid grid-list-md v-if="fileList && fileList.length">
      <h2 class="subheading">Files</h2>
      <v-layout
        v-if="loadingFiles"
        fill-height
        align-center
        justify-center
        ma-0
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>




      <v-data-iterator
        v-if="!loadingFiles && fileList && fileList.length"
        :items="fileList"
        item-key="name"
        :hide-actions="hideFileAction"
        :rows-per-page-items="fileRowsPerPageItems"
        :pagination.sync="filePagination"
        content-tag="div"
        content-class="layout row wrap"
        no-results-text="No Files found."
      >
        <template v-slot:item="props">
          <v-flex xs6 sm6 md4 lg2 xl1>
            <v-card elevation="0" @click="fileClicked(props.item)">
              <v-card-text class="text-xs-center pointer">
                <div style="font-size: 100px" :class="'fiv-cla fiv-icon-blank fiv-icon-' + props.item.extension"></div><br />
                <div class="text-truncate caption pt-3">
                  {{ props.item.name }} 
                </div>
              </v-card-text>
            </v-card>
            <!-- <v-card
              v-if="
                props.item.file_type.includes('image') &&
                props.item.size <= 5000000
              "
              style="height: 200px; cursor: pointer"
              @click="fileClicked(props.item)"
            >
   
                <v-img
                  :src="props.item.url"
                  aspect-ratio="1"
                  :max-height="200"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
    
            </v-card>
            <v-card
              v-if="
                !props.item.file_type.includes('image') ||
                props.item.size > 5000000"
              style="height: 200px; cursor: pointer"
              @click="fileClicked(props.item)"
            >
              <v-layout fill-height align-center justify-center>
                  <span class="text-truncate caption">{{
                    props.item.name
                  }}</span>
              </v-layout>
            </v-card> -->
          </v-flex>
        </template>
      </v-data-iterator>
    </v-container>

    <v-dialog v-model="uploadFilesDialog" persistent :hide-overlay="false">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn
            icon
            dark
            @click="
              uploadFilesDialog = false;
              files = [];
              getFiles(currentFolder);
              closeUploadDialog();
            "
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Upload Files</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
            <v-btn dark flat @click="uploadFilesDialog = false">Save</v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <vue-dropzone
                ref="myVueDropzone"
                id="drop1"
                style="min-height: 500px"
                :awss3="awss3"
                :options="dropOptions"
                @vdropzone-success="vSuccess"
                @vdropzone-removed-file="vRemoved"
                @vdropzone-queue-complete="vQueueComplete"
                v-on:vdropzone-sending="sendingEvent"
                v-on:vdropzone-s3-upload-error="s3UploadError"
                v-on:vdropzone-s3-upload-success="s3UploadSuccess"
              >
                Click here to upload <br />
                Or <br />
                Drop files here or click to upload
              </vue-dropzone>
            </v-flex>
          </v-layout>
        </v-card-text>
         <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="
              uploadFilesDialog = false;
              files = [];
              getFiles(currentFolder);
              closeUploadDialog();
            ">Close</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="createFolderDialog"
      persistent
      :hide-overlay="false"
      width="500"
    >
      <v-card>
        <v-form id="create-folder-form" @submit.prevent="createFolder()">
          <v-card-title>
            <span class="headline">New Folder</span>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Folder Name"
                  v-model="newFolderName"
                  required
                  outline
                  placeholder=" "
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="createFolderDialog = false">Cancel</v-btn>
            <v-btn color="primary" type="submit" :loading="creating"
              >Create</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import awsEndpoint from "./urlsigner";
import DMSService from "@/services/dms.service";

import { createNamespacedHelpers } from "vuex";
const {
  mapState,
  mapActions,
  mapGetters,
  mapMutations,
} = createNamespacedHelpers("dataSources");

function getBreadcrumb(list, currentFolder, result) {
  const f = { ...currentFolder };
  result.unshift(f);
  const parentFolder = list.find((item) => item.id == f.parent_id);
  if (!parentFolder || currentFolder.parent_id == 0) {
    return result;
  }
  return getBreadcrumb(list, parentFolder, result);
}

const dataSourceNamespace = createNamespacedHelpers("dataSources");
const chartNamespace = createNamespacedHelpers("charts");
import ApiService from "@/services/api.service";

export default {
  props: ["chart", "namespace", "mode", "description", "element", "events"],
  data: function () {
    let params = this.$route.params;
    const that = this;
    let url =
      ApiService.getBaseUrl() +
      "/datasource/documents/" +
      params.projectId +
      "/uploadFile";
    return {
      hideFolderAction: false,
      folderRowsPerPageItems: [10, 20, 25, 30, 40, 50],
      folderPagination: {
        rowsPerPage: 20
      },
      hideFileAction: false,
      fileRowsPerPageItems: [10, 20, 25, 30, 40, 50],
      filePagination: {
        rowsPerPage: 20
      },
      breadcrumb: [],
      loadingFolders: false,
      loadingFiles: false,
      selectedNamespace: null,
      namespaceDescription: "Documents",
      uploadFilesDialog: false,
      files: [],
      folderList: [],
      activeFolderList: [],
      fileList: [],
      activeFileList: [],
      creating: false,
      rootFolder: {
        id: 0,
        namespace: null,
        name: null,
        parent_id: 0,
        project_id: null,
      },
      currentFolder: {
        id: 0,
        namespace: null,
        name: null,
        parent_id: 0,
        project_id: null,
      },
      newFolderName: "",
      createFolderDialog: false,
      folder: "/",
      config: {
        access: "public-read",
      },
      folder_id: null,
      display: "progress",
      message: "",
      dialog: false,
      mergeDialog: false,
      awss3: {
        //signingURL: ApiService.getBaseUrl() + "/datasource/document/signature",
        signingURL: function (file) {
          try {
            // let params = this.$route.params;
            // console.log("f", file.width);
            // folder: this.folder,
            let params = that.createPayload(file);
            params.name = file.name;
            params.size = file.size;
            params.file_type = file.type;

            if (typeof file.width != "undefined") {
              params.width = file.width;
            }
            if (typeof file.height != "undefined") {
              params.height = file.height;
            }
            console.log("params", params);
            const paramString = Object.keys(params)
              .map(function (key) {
                return key + "=" + encodeURIComponent(params[key]);
              })
              .join("&");
            // alert(paramString);
            return (
              ApiService.getBaseUrl() + "/dms/document/signature?" + paramString
            );
            // return (
            //   ApiService.getBaseUrl() + "/datasource/document/signature?" + paramString
            // );
          } catch (error) {
            console.log(error);
          }
        },
        headers: ApiService.getHeader(),
        params: {},
        sendFileToServer: false,
        withCredentials: true,
      },
      dropOptions: {
        // url: url,
        //headers: ApiService.getHeader(),
        maxFilesize: 500, // MB
        maxFiles: 100,
        timeout: 900000, // 15 minutes
        addRemoveLinks: true,
        autoProcessQueue: true,
        method: "PUT",
        sending: function (file, xhr) {
          // alert("hey");
          let _send = xhr.send;
          xhr.send = () => {
            _send.call(xhr, file);
          };
        },
        // headers: {
        //   "Accept": "*/*",
        //   "Content-Disposition": "attachment"
        //    // "Content-Type": "multipart/form-data"
        // },
        // acceptedFiles: "*",
      },
    };
  },
  name: "dms",
  components: {
    "vue-dropzone": VueDropzone,
  },
  computed: {
    ...chartNamespace.mapState({
      projectId: (state) => state.projectId,
    }),
  },
  methods: {
    closeUploadDialog() {
      this.$refs.myVueDropzone.removeAllFiles();
    },
    openUploadFilesDialog() {
      this.$refs.myVueDropzone.removeAllFiles();
      this.uploadFilesDialog = true;
    },
    sendingEvent(file, xhr, formData) {
      // formData.append('paramName', 'some value or other');
    },
    updateName: function (event) {
      // this.mSetName(event.target.innerText);
    },
    iMerge: async function () {},
    reload: async function () {
      this.dialog = false;
    },
    vSuccess(file, response) {
      console.log("vsuccess", file);
      console.log("response", response);
      let payload = this.createPayload(file);

      this.files.push(file);
      DMSService.createFile(payload);
    },
    vRemoved(file, error, xhr) {
      console.log("vremoved", file);
      this.files = this.files.filter((item) => item.name != file.name);
    },
    vQueueComplete() {
      console.log("vQueueComplete", this.files);
    },
    s3UploadSuccess(file, error, xhr) {
      console.log("s3UploadSuccess", file);
    },
    s3UploadError() {
      console.log("vsuccess", file);
    },
    uploadFiles() {
      //if (this.signurl) {
      //   this.$refs.myVueDropzone.setAWSSigningURL(this.signurl);
      this.$refs.myVueDropzone.processQueue();

      //   }
      //   else {
      //     // this.$refs.urlsigner.focus();
      //     // alert("Enter your signing URL");
      //   }
    },
    createPayloads(files) {
      let list = [];
      for (let i = 0; i < files.length; i++) {
        list.push(this.createPayload(files[i]));
      }
      return list;
    },
    createPayload(file) {
      let payload = { ...this.config };
      payload.name = file.name;
      payload.namespace = this.selectedNamespace;
      payload.project_id = this.projectId;
      payload.folder_id = this.currentFolder.id;
      payload.size = file.size;
      payload.file_type = file.type;

      payload.last_modified = file.lastModified;

      if (typeof file.s3Url != "undefined") {
        payload.url = file.s3Url.split("?")[0];
      }

      if (typeof file.width != "undefined") {
        payload.width = file.width;
      }
      if (typeof file.height != "undefined") {
        payload.height = file.height;
      }
      return payload;
    },
    vsuccessMultiple(files, response) {
      console.log("vsuccessMultiple", files);
    },
    async vqueueComplete(file, xhr, formData) {
      this.queueComplete = true;
      this.mSetProjectId(this.$route.params.projectId);
      this.dialog = false;
    },
    vfileAdded(file) {
      this.message = "Importing file(s)";
      this.display = "progress";
      this.dialog = true;
    },
    setCurrentFolder(folder) {
      this.files = [];
      if (folder.id != this.currentFolder) {
        this.files = [];
      }
      this.currentFolder = { ...folder };
      this.currentFolder.namespace = this.selectedNamespace;
      this.currentFolder.project_id = this.projectId;

      this.setActiveFolders(this.currentFolder, this.folderList);

      const breadcrumb = getBreadcrumb(this.folderList, this.currentFolder, []);
      this.breadcrumb = breadcrumb;

      console.log("breadcrumb folder", folder);
      console.log("breadcrumb", breadcrumb);
      console.log("breadcrumb", this.activeFolderList);

      this.getFiles(this.currentFolder);
    },
    async createFolder() {
      this.creating = true;
      try {
        const payload = {
          name: this.newFolderName,
          parent_id: this.currentFolder.id,
          namespace: this.selectedNamespace,
          project_id: this.projectId,
        };

        const response = await DMSService.createFolder(payload);
        const folder = response.data;
        this.folderList.push(folder);

        this.setActiveFolders(this.currentFolder, this.folderList);
        this.newFolderName = "";

        // this.currentFolder = response.data;
      } catch (error) {
        // alert(error);
      }

      this.creating = false;
      this.createFolderDialog = false;
    },
    openFolder(id) {},
    async getFiles(folder) {
      this.loadingFiles = true;
      let payload = { ...folder };
      payload.folder_id = payload.id;
      const response = await DMSService.getFiles(payload);
      this.setFiles(response.data.results);
      this.loadingFiles = false;
    },
    setFiles(files) {
      // let fileList = []...files};
      const fileList = files.map(file => {
        const ext = file.name.split('.').pop().toLowerCase();
        file.extension = ext ? ext : 'blank';
        return file;
      });

      this.fileList = fileList;
      this.hideFileAction = fileList.length < this.filePagination.rowsPerPage ? true : false;

    },
    setActiveFolders(folder, list) {
      this.activeFolderList = list.filter(
        (item) => item.parent_id == folder.id
      );
      console.log("folder", folder);
      console.log("list", list);
      console.log("this.activeFolderList", this.activeFolderList);
    },
    async getFolders(folder) {
      this.loadingFolders = true;
      const response = await DMSService.getFolders(folder);
      const folderList = response.data.results;
      this.folderList = folderList;
      this.hideFolderAction = folderList.length < this.folderPagination.rowsPerPage ? true : false;
      this.setActiveFolders(folder, this.folderList);
      // console.log("getFolders response", response);
      this.loadingFolders = false;
    },
    fileClicked(file) {
      if(this.mode == 'select') {
        console.log("this.element", this.element);
        this.events.selectFile(file);

      } else {
        const win = window.open(file.url, '_blank');
        win.focus();
      }
    }
  },
  beforeMount() {

  },
  mounted: function () {
    this.files = [];
    const that = this;

    // if(this.element) {
    //   console.log("mounted this.element", this.element.selectFile);
    // }



    if (this.mode == "select") {
      that.selectedNamespace = this.namespace;
      that.setCurrentFolder(that.currentFolder);
      that.rootFolder = { ...that.currentFolder };
      // console.log("currentFolder", that.currentFolder);
      that.getFolders(that.currentFolder);
      if (that.description) {
        that.namespaceDescription = that.description;
      }
    } else if (that.chart && that.chart.parameters) {
          this.chart.uiUpdate = function () {
      // this.selectedNamespace = this.namespace;
      if (that.chart.parameters.namespace.value) {
        if (that.chart.parameters.namespace.value == that.selectedNamespace) {
          return false;
        }
        that.selectedNamespace = that.chart.parameters.namespace.value;
        // alert(that.selectedNamespace);
      }

      if (that.chart.parameters.namespaceDescription.value) {
        that.namespaceDescription =
          that.chart.parameters.namespaceDescription.value;
      }

      that.setCurrentFolder(that.currentFolder);
      that.rootFolder = { ...that.currentFolder };

      // console.log("currentFolder", that.currentFolder);
      that.getFolders(that.currentFolder);
    };

      this.chart.uiUpdate();
    }

    // vm.dropzone.on("sending", function(file, xhr, formData) {
    //   if (vm.isS3) {
    //     if (vm.isS3OverridesServerPropagation) {
    //       alert("hey");
    //       let signature = file.s3Signature;
    //       Object.keys(signature).forEach(function(key) {
    //         formData.append(key, signature[key]);
    //       });
    //     } else {
    //       formData.append("s3ObjectLocation", file.s3ObjectLocation);
    //     }
    //   }
    //   vm.$emit("vdropzone-sending", file, xhr, formData);
    // });

    // console.log("vm", vm);

    // vm.dropzone.options.sending = function(file, xhr) {
    //     let _send = xhr.send;
    //     xhr.send = () => {
    //       alert("sending");
    //       _send.call(xhr, file);
    //     }
    //   };

    //     vm.getSignedAndUploadToS3 = function(file) {

    //       var promise = awsEndpoint.sendFile(
    //         file,
    //         this.awss3,
    //         this.isS3OverridesServerPropagation
    //       );
    //       if (!this.isS3OverridesServerPropagation) {
    //        // alert("process file 1");
    //         promise.then(response => {
    //           if (response.success) {
    //             file.s3ObjectLocation = response.message;
    //             setTimeout(() => this.dropzone.processFile(file));
    //             this.$emit("vdropzone-s3-upload-success", response.message);
    //           } else {
    //             if ("undefined" !== typeof response.message) {
    //               this.$emit("vdropzone-s3-upload-error", response.message);
    //             } else {
    //               this.$emit(
    //                 "vdropzone-s3-upload-error",
    //                 "Network Error : Could not send request to AWS. (Maybe CORS error)"
    //               );
    //             }
    //           }
    //         });
    //       } else {
    //         promise.then(() => {
    //           // alert("process file 2");
    //           console.log("processfile", file);
    //           console.log("processfile", this.dropzone);

    //           setTimeout(() => this.dropzone.processFile(file));
    //         });
    //       }
    //       promise.catch(error => {
    //         alert(error);
    //       });
    //     }
  },
  beforeCreate: function () {},
};
</script>
